import React, { useCallback, useEffect, useState } from 'react';

import UFilterSelect from 'Components/unit/UFilterSelect/UFilterSelect';
import type { Filter, FilterItem } from 'Libs/filter/types';
import { getCoursesOptions } from 'Store/entities/course/course.api';

import styles from './CourseSelect.style';

type CourseSelectProps = {
  selectedCourseIds: number[];
  handleSelectedItems: (filterCategory: 'courses', value: FilterItem[]) => void;
};

const CourseSelect: React.FC<CourseSelectProps> = ({ selectedCourseIds, handleSelectedItems }) => {
  const [courses, setCourses] = useState<Filter>({
    category: 'course',
    type: 'multiselect',
    items: [],
  });

  const fetchCourses = useCallback(async () => {
    const courses = await getCoursesOptions();

    const items: FilterItem[] = courses.map((course) => {
      return {
        category: 'course',
        id: course.id,
        value: course.title,
        selected: selectedCourseIds.includes(course.id),
      };
    });

    setCourses({ category: 'course', type: 'multiselect', items });
  }, [selectedCourseIds]);

  const onFilterChange = useCallback(
    (value: Filter) => {
      setCourses(value);

      const selectedCourses = value.items.filter((item) => item.selected);
      handleSelectedItems('courses', selectedCourses);
    },
    [handleSelectedItems],
  );

  // Retrieve courses list on mount
  useEffect(() => {
    fetchCourses();
  }, []);

  // Update selected courses on selectedCourseIds change
  useEffect(() => {
    if (courses.items.length > 0) {
      const newCoursesItems = courses.items.map((item) => {
        return {
          ...item,
          selected: selectedCourseIds.includes(item.id),
        };
      });

      setCourses({ category: 'course', type: 'multiselect', items: newCoursesItems });
    }
  }, [selectedCourseIds]);

  return <UFilterSelect filter={courses} onFilterChanged={onFilterChange} style={styles.filter} />;
};

export default CourseSelect;
